

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { Service } from './service';

export interface LabTestParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface LabTest {
    zeroServiceFlag?:string;
    branchSrvc?: any;
    labtest?: any;
    id?: any;
    tenantId: any;
    branchId: any;

    serviceId:any;
    unitId:any;
    labCategoryId:any;

    defaultValue:string;

    commonMinValue:number;
    commonMaxValue:number;
    childrenMinValue:number;
    childrenMaxValue:number;
    maleMinValue:number;
    maleMaxValue:number;
    femaleMinValue:number;
    femaleMaxValue:number;
    othersMinValue:string;
    othersMaxValue:string;
    isActive:string;
    labTestMethodId?:any;
    labTestMaterialId?:any;
    isCultureTest: string;
    mappedAntibiotics: any ;
    isHistopathologyTest?:string;
    isCytologyTest?: boolean;
    parameters?: LabTestParameter[];
    links?: any;
    service?:Service;
    labTestMethod?:any;
    labTestMaterial?:any;
    outsideLabId?:any;
    sampleType?:any;
    //New field added for lab normal range display value - abirami - 26/8/22
    displayValue:any;
    isTargetProperties?:any;
    targetValue?:any;
    srvReqNo?:string;
    isSelfCalculation?:string;
    restrictType?: string;
    restrictDays?: string;
    showGraph?: string;
    previousGraphCount?: number;
    inputControlType?:string,
    inputDataType?: string,
    inputDropDownValues?:string,
    inputLength?: number,   
    hsnCode?:string;
    serAccountCode?:string; 
    type?:string;
    aliasName? : string;
    iscutoffValue?:string;
    hospitalShare?:number,
    refShare?: number,
        labTestCode?:string;
    IsShukhee?:boolean;
}



export abstract class LabTestData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<LabTest[]>;
    abstract create(url: string, data: LabTest): Observable<LabTest[]>;
    abstract update(url: string, data: LabTest): Observable<LabTest>;
    abstract delete(url: string): Observable<any>;
    abstract postData(url:string,data:any[]):Observable<any>;
}
